import { Array } from 'stdlib/Array'

import type { TBrowser } from '../definitions'
import { FF_BROWSERS } from '../definitions'

/**
 * Firefox-ot használ a user.
 * @param browser - Browser típusa.
 */
export default function isFF (browser: TBrowser): boolean { // eslint-disable-line @typescript-eslint/naming-convention
  return Array.includes(FF_BROWSERS, browser)
}
